export * from './LegacyHeatmap';
